
import { useArticleLike } from './useArticleLike';
import { useArticleFavorite } from './useArticleFavorite';
import { useArticleDislike } from './useArticleDislike';
import { useArticleComment } from './useArticleComment';

export const useArticleInteractions = (articleId: string) => {
  const { handleLike, isLiked, isCheckingLike } = useArticleLike(articleId);
  const { handleFavorite, isFavorited, isCheckingFavorite } = useArticleFavorite(articleId);
  const { handleDislike } = useArticleDislike();
  const { handleComment } = useArticleComment(articleId);

  const isCheckingInteractions = isCheckingLike || isCheckingFavorite;

  return {
    handleLike,
    handleDislike,
    handleFavorite,
    handleComment,
    isLiked,
    isFavorited,
    isCheckingInteractions
  };
};
